import * as React from "react";
import classNames from "classnames";
import Icon from "../shared-icon";
import "./link-button.scss";

/**
 * LinkButton component
 *
 * @param {Object} props - Component properties
 * @param {string} [props.ariaLabel] - ARIA label for accessibility
 * @param {React.RefObject} [props.buttonRef] - Button reference
 * @param {string} [props.className] - Additional class names
 * @param {React.ElementType} [props.icon] - Icon component
 * @param {string} [props.iconPosition] - Position of the icon ("before" or "after")
 * @param {string} [props.iconText] - Text for the icon title
 * @param {function} [props.onClick] - Click event handler
 * @param {boolean} [props.primaryLink=false] - Whether the button is a primary link
 * @param {React.Element} [props.PLIconContent] - Custom icon content
 * @param {string} [props.text] - Button text
 * @param {string} [props.type="button"] - Button type
 * @param {Object} [props.otherProps] - Other properties
 * @returns {JSX.Element} The rendered button component
 */

const LinkButton = ({
  ariaLabel = null,
  buttonRef = null,
  className = "",
  icon,
  iconPosition,
  iconText,
  onClick,
  primaryLink = false,
  PLIconContent = null,
  text,
  type = "button",
  ...otherProps
}) => (
  <button
    type={type}
    className={classNames("lll-text-primary", {
      "link-button": true,
      [className]: !!className
    })}
    onClick={onClick}
    ref={buttonRef}
    aria-label={ariaLabel}
    {...otherProps}
  >
    {(icon || PLIconContent) && (
      <span
        className={classNames({
          "link-button__icon": true,
          "link-button__icon--after": iconPosition === "after"
        })}
      >
        <Icon
          content={icon}
          PLIconContent={PLIconContent}
          title={`${iconText || text || ""}`}
        />
      </span>
    )}
    {text && (
      <span
        className={classNames({
          "link-button__text": true,
          "lll-link-primary": primaryLink
        })}
      >
        {text}
      </span>
    )}
  </button>
);

export default LinkButton;
